import * as ambassadorWixIdentityRolesV1User from './identity-roles-v1-user-users.http.js';
import * as ambassadorWixIdentityRolesV1UserTypes from './identity-roles-v1-user-users.types.js';
import * as ambassadorWixIdentityRolesV1UserUniversalTypes from './identity-roles-v1-user-users.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function removeMember(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityRolesV1UserUniversalTypes.RemoveMemberRequest,
  ambassadorWixIdentityRolesV1UserTypes.RemoveMemberRequest,
  ambassadorWixIdentityRolesV1UserUniversalTypes.RemoveMemberResponse,
  ambassadorWixIdentityRolesV1UserTypes.RemoveMemberResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityRolesV1User.removeMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/team/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchTeam(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityRolesV1UserUniversalTypes.SearchTeamRequest,
  ambassadorWixIdentityRolesV1UserTypes.SearchTeamRequest,
  ambassadorWixIdentityRolesV1UserUniversalTypes.SearchTeamResponse,
  ambassadorWixIdentityRolesV1UserTypes.SearchTeamResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityRolesV1User.searchTeam(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/team/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRolesInfo(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIdentityRolesV1UserUniversalTypes.GetRolesInfoRequest,
  ambassadorWixIdentityRolesV1UserTypes.GetRolesInfoRequest,
  ambassadorWixIdentityRolesV1UserUniversalTypes.GetRolesInfoResponse,
  ambassadorWixIdentityRolesV1UserTypes.GetRolesInfoResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityRolesV1User.getRolesInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/roles',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeRoleV2(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixIdentityRolesV1UserUniversalTypes.ChangeRoleV2Request,
  ambassadorWixIdentityRolesV1UserTypes.ChangeRoleV2Request,
  ambassadorWixIdentityRolesV1UserUniversalTypes.ChangeRoleV2Response,
  ambassadorWixIdentityRolesV1UserTypes.ChangeRoleV2Response
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityRolesV1User.changeRoleV2(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/team/roles',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTeamMemberAssignments(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixIdentityRolesV1UserUniversalTypes.UpdateTeamMemberAssignmentsRequest,
  ambassadorWixIdentityRolesV1UserTypes.UpdateTeamMemberAssignmentsRequest,
  ambassadorWixIdentityRolesV1UserUniversalTypes.UpdateTeamMemberAssignmentsResponse,
  ambassadorWixIdentityRolesV1UserTypes.UpdateTeamMemberAssignmentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityRolesV1User.updateTeamMemberAssignments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/team/assignments',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  User as UserOriginal,
  Name as NameOriginal,
  Assignment as AssignmentOriginal,
  AssignedPolicy as AssignedPolicyOriginal,
  Restriction as RestrictionOriginal,
  RestrictionRestrictionsOneOf as RestrictionRestrictionsOneOfOriginal,
  ApiResource as ApiResourceOriginal,
  ResourceType as ResourceTypeOriginal,
  ResourceTypeWithLiterals as ResourceTypeWithLiteralsOriginal,
  Conditions as ConditionsOriginal,
  ApiCondition as ApiConditionOriginal,
  ConditionAttributeType as ConditionAttributeTypeOriginal,
  ConditionAttributeTypeWithLiterals as ConditionAttributeTypeWithLiteralsOriginal,
  SiteRestriction as SiteRestrictionOriginal,
  CompanionResource as CompanionResourceOriginal,
  LocationsRestriction as LocationsRestrictionOriginal,
  Subject as SubjectOriginal,
  SubjectType as SubjectTypeOriginal,
  SubjectTypeWithLiterals as SubjectTypeWithLiteralsOriginal,
  SubjectContext as SubjectContextOriginal,
  SubjectContextType as SubjectContextTypeOriginal,
  SubjectContextTypeWithLiterals as SubjectContextTypeWithLiteralsOriginal,
  GetTeamRequest as GetTeamRequestOriginal,
  Paging as PagingOriginal,
  GetTeamResponse as GetTeamResponseOriginal,
  AccountInvite as AccountInviteOriginal,
  InviteStatus as InviteStatusOriginal,
  InviteStatusWithLiterals as InviteStatusWithLiteralsOriginal,
  InviteResourceAssignment as InviteResourceAssignmentOriginal,
  InviteAssignment as InviteAssignmentOriginal,
  FullNameResource as FullNameResourceOriginal,
  FullNameResourceResourceContextOneOf as FullNameResourceResourceContextOneOfOriginal,
  SiteResourceContext as SiteResourceContextOriginal,
  AccountResourceContext as AccountResourceContextOriginal,
  OrganizationResourceContext as OrganizationResourceContextOriginal,
  Resource as ResourceOriginal,
  PolicyCondition as PolicyConditionOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeOfOneOf as ConditionTypeOfOneOfOriginal,
  SimpleCondition as SimpleConditionOriginal,
  SimpleConditionValue as SimpleConditionValueOriginal,
  SimpleConditionValueValueOneOf as SimpleConditionValueValueOneOfOriginal,
  SimpleConditionOperator as SimpleConditionOperatorOriginal,
  SimpleConditionOperatorWithLiterals as SimpleConditionOperatorWithLiteralsOriginal,
  JoinedCondition as JoinedConditionOriginal,
  JoinedConditionOperator as JoinedConditionOperatorOriginal,
  JoinedConditionOperatorWithLiterals as JoinedConditionOperatorWithLiteralsOriginal,
  EnvironmentCondition as EnvironmentConditionOriginal,
  EnvironmentConditionConditionOneOf as EnvironmentConditionConditionOneOfOriginal,
  ExperimentCondition as ExperimentConditionOriginal,
  Condition as ConditionOriginal,
  ConditionOperator as ConditionOperatorOriginal,
  ConditionOperatorOperatorsOneOf as ConditionOperatorOperatorsOneOfOriginal,
  EqualOperator as EqualOperatorOriginal,
  ConditionValue as ConditionValueOriginal,
  ConditionValueValueOneOf as ConditionValueValueOneOfOriginal,
  LikeOperator as LikeOperatorOriginal,
  ExperimentOperator as ExperimentOperatorOriginal,
  DependOnOperator as DependOnOperatorOriginal,
  AccountInfo as AccountInfoOriginal,
  ApiPolicy as ApiPolicyOriginal,
  PredefinedRoles as PredefinedRolesOriginal,
  PredefinedRole as PredefinedRoleOriginal,
  Role as RoleOriginal,
  ChangeRoleRequest as ChangeRoleRequestOriginal,
  ChangeRoleResponse as ChangeRoleResponseOriginal,
  RemoveMemberRequest as RemoveMemberRequestOriginal,
  RemoveMemberResponse as RemoveMemberResponseOriginal,
  GetUsersRequest as GetUsersRequestOriginal,
  GetUsersResponse as GetUsersResponseOriginal,
  GetScopesRequest as GetScopesRequestOriginal,
  GetScopesResponse as GetScopesResponseOriginal,
  ScopeArea as ScopeAreaOriginal,
  PermissionScope as PermissionScopeOriginal,
  ScopeLevel as ScopeLevelOriginal,
  ScopeLevelWithLiterals as ScopeLevelWithLiteralsOriginal,
  Visibility as VisibilityOriginal,
  VisibilityWithLiterals as VisibilityWithLiteralsOriginal,
  GetScopesV2Request as GetScopesV2RequestOriginal,
  GetScopesV2Response as GetScopesV2ResponseOriginal,
  ScopeAreaV2 as ScopeAreaV2Original,
  PermissionScopeV2 as PermissionScopeV2Original,
  GetPeopleRequest as GetPeopleRequestOriginal,
  PeopleResource as PeopleResourceOriginal,
  PeopleResourceResourceTypeOneOf as PeopleResourceResourceTypeOneOfOriginal,
  FolderResource as FolderResourceOriginal,
  PeopleType as PeopleTypeOriginal,
  PeopleTypeWithLiterals as PeopleTypeWithLiteralsOriginal,
  GetPeopleResponse as GetPeopleResponseOriginal,
  People as PeopleOriginal,
  Person as PersonOriginal,
  PersonPersonOneOf as PersonPersonOneOfOriginal,
  Contributor as ContributorOriginal,
  PersonMetaData as PersonMetaDataOriginal,
  AccountGroup as AccountGroupOriginal,
  AccountGroupWithLiterals as AccountGroupWithLiteralsOriginal,
  TeamMember as TeamMemberOriginal,
  GetTeamV2Response as GetTeamV2ResponseOriginal,
  GetTeamInvitesRequest as GetTeamInvitesRequestOriginal,
  GetTeamInvitesResponse as GetTeamInvitesResponseOriginal,
  Invite as InviteOriginal,
  ApiInviteAssignment as ApiInviteAssignmentOriginal,
  GetPoliciesRequest as GetPoliciesRequestOriginal,
  AreasFilter as AreasFilterOriginal,
  RoleLevel as RoleLevelOriginal,
  RoleLevelWithLiterals as RoleLevelWithLiteralsOriginal,
  GetPoliciesResponse as GetPoliciesResponseOriginal,
  SearchTeamRequest as SearchTeamRequestOriginal,
  Ordering as OrderingOriginal,
  OrderField as OrderFieldOriginal,
  OrderFieldWithLiterals as OrderFieldWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  FacetType as FacetTypeOriginal,
  FacetTypeWithLiterals as FacetTypeWithLiteralsOriginal,
  SearchTeamResponse as SearchTeamResponseOriginal,
  Facet as FacetOriginal,
  FacetValue as FacetValueOriginal,
  TeamMemberV3 as TeamMemberV3Original,
  TeamMemberV3MembersOneOf as TeamMemberV3MembersOneOfOriginal,
  UserV3 as UserV3Original,
  AssignmentV3 as AssignmentV3Original,
  AssignedSubject as AssignedSubjectOriginal,
  InviteV3 as InviteV3Original,
  InviteAssignmentV3 as InviteAssignmentV3Original,
  GetRolesRequest as GetRolesRequestOriginal,
  GetRolesResponse as GetRolesResponseOriginal,
  PredefinedRolesArea as PredefinedRolesAreaOriginal,
  PredefinedRoleV2 as PredefinedRoleV2Original,
  RoleLevelRestriction as RoleLevelRestrictionOriginal,
  RoleLevelRestrictionWithLiterals as RoleLevelRestrictionWithLiteralsOriginal,
  EditorType as EditorTypeOriginal,
  EditorTypeWithLiterals as EditorTypeWithLiteralsOriginal,
  RoleVisibility as RoleVisibilityOriginal,
  RoleVisibilityWithLiterals as RoleVisibilityWithLiteralsOriginal,
  CustomRole as CustomRoleOriginal,
  GetRolesInfoRequest as GetRolesInfoRequestOriginal,
  RolesInfoFilter as RolesInfoFilterOriginal,
  GetRolesInfoResponse as GetRolesInfoResponseOriginal,
  RoleInfo as RoleInfoOriginal,
  CreateCustomRoleRequest as CreateCustomRoleRequestOriginal,
  Policy as PolicyOriginal,
  PolicyType as PolicyTypeOriginal,
  PolicyTypeWithLiterals as PolicyTypeWithLiteralsOriginal,
  PolicyStatement as PolicyStatementOriginal,
  Effect as EffectOriginal,
  EffectWithLiterals as EffectWithLiteralsOriginal,
  CreateCustomRoleResponse as CreateCustomRoleResponseOriginal,
  ChangeRoleV2Request as ChangeRoleV2RequestOriginal,
  ChangeRoleV2Response as ChangeRoleV2ResponseOriginal,
  UpdateTeamMemberAssignmentsRequest as UpdateTeamMemberAssignmentsRequestOriginal,
  UpdateTeamMemberAssignmentsResponse as UpdateTeamMemberAssignmentsResponseOriginal,
  GetSubjectsAssignmentsRequest as GetSubjectsAssignmentsRequestOriginal,
  GetSubjectsAssignmentsResponse as GetSubjectsAssignmentsResponseOriginal,
  SubjectAssignments as SubjectAssignmentsOriginal,
  GetScopesByRoleRequest as GetScopesByRoleRequestOriginal,
  GetScopesByRoleResponse as GetScopesByRoleResponseOriginal,
  GetRolesV2Request as GetRolesV2RequestOriginal,
  GetRolesV2Response as GetRolesV2ResponseOriginal,
  PredefinedRolesAreaV2 as PredefinedRolesAreaV2Original,
  RoleInfoV2 as RoleInfoV2Original,
  CustomRoleV2 as CustomRoleV2Original,
  GetRolesBackofficeRequest as GetRolesBackofficeRequestOriginal,
  GetRolesBackofficeResponse as GetRolesBackofficeResponseOriginal,
  GetScopesBackofficeRequest as GetScopesBackofficeRequestOriginal,
  GetScopesBackofficeResponse as GetScopesBackofficeResponseOriginal,
} from './identity-roles-v1-user-users.types.js';
